<template>
  <v-dialog width="350px" :visible.sync="dialogVisible" :scrollbar="false" @closed="onClosed" @open="onOpen">
    <div class="qrcode">
      <h3>{{ innerTitle }}</h3>
      <el-image :src="qrcodeUrl" v-loading="loading" @load="imageLoad">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div slot="footer">
      <el-button plain icon="el-icon-printer" @click="handlePrint" :disabled="!qrcodeUrl" />
    </div>
  </v-dialog>
</template>

<script>
import printJS from "print-js";
export default {
  name: "QRCodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      type: String,
      default: "SE/CE"
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: true,
      qrcodeUrl: "",
      printerOptions: {
        id: "qrcode",
        popTitle: "SE/CE QR Code",
      },
    };
  },
  computed: {
    innerTitle() {
      // return this.data
      //   ? `${this.title} QR Code For ${this.data.SEName}(${this.title} No.${this.data.SENo})`
      //   : `${this.title} QR Code`;
      return this.data
        ? `请${this.data.SEName}老师扫码`
        : `请扫码`;
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    printJS,
    onClosed() {
      this.qrcodeUrl = "";
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    onOpen() {
      if (this.data) {
        this.loading = true;
        this.axios
          .get("/se/qrCode", {
            params: {
              seId: this.data.SEID,
            },
          })
          .then(({ code, data }) => {
            if (code === 200) {
              this.qrcodeUrl = data;
            } else {
              this.$message.error("Get QR Code failed");
            }
          });
      }
    },
    imageLoad() {
      this.loading = false;
    },
    handlePrint() {
      this.printJS({
        printable: `<div class="qrcode-wrapper"><h4>${this.innerTitle}</h4><img class="qrcode-img" src="${this.qrcodeUrl}"/></div>`,
        type: "raw-html",
        style:
          ".qrcode-wrapper {height:800px;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;} .qrcode-img{width:230px;height:230px;}",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-image {
  width: 200px;
  height: 200px;
}

::v-deep {
  .el-dialog__header {
    height: 45px;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    text-align: right;
    padding: 0 20px 20px;
  }
}

.qrcode {
  position: relative;
  padding: 30px;

  h3 {
    color: #000;
  }

  .el-image {
    margin-top: 20px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
